import { useState } from 'react';
import { BellRing, MonitorCheck } from 'lucide-react';
import { FOCUS_RING } from '../../vessel-changes';
import { askForDesktopAlerts, desktopAlertState, type DesktopAlertState } from '../alerts/desktopAlerts';

/**
 * The ship bell's footer: the desktop pop-ups (asks the browser once; when refused, says where to allow
 * them). No alarm sound (owner, 2026-10-13); muted so it never competes with the alerts above it.
 */
export function DesktopAlertSettings() {
  const [desktop, setDesktop] = useState<DesktopAlertState>(desktopAlertState);

  const turnOnDesktop = async () => setDesktop(await askForDesktopAlerts());

  return (
    <div className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-t border-slate-100 bg-slate-50 px-3 py-1.5 text-[11px] text-slate-500">
      <DesktopAlertControl state={desktop} onTurnOn={turnOnDesktop} />
    </div>
  );
}

function DesktopAlertControl({ state, onTurnOn }: { state: DesktopAlertState; onTurnOn: () => void }) {
  if (state === 'unsupported') return null;
  if (state === 'granted') {
    return (
      <span className="inline-flex items-center gap-1">
        <MonitorCheck className="h-3.5 w-3.5" />
        Desktop alerts on
      </span>
    );
  }
  if (state === 'denied') {
    return <span>Allow notifications for this site in the browser settings</span>;
  }
  return (
    <button type="button" onClick={onTurnOn} className={`inline-flex items-center gap-1 rounded font-medium text-slate-600 hover:text-slate-900 hover:underline ${FOCUS_RING}`}>
      <BellRing className="h-3.5 w-3.5" />
      Turn on desktop alerts
    </button>
  );
}
